// Descritor sem render: o Root o converte em `model` do Menu via `toItem`; o nome `view-` é exigência do contrato de estrutura.
import { TABLE_ACTIONS_EXPORT_LABEL } from "../messages";
import type { ItemProps, ShortcutItemProps } from "../types-table-actions-menu";

/** "Exportar Visualização" (GLOSSARIO.md, "Listagens"); testId `<testId do Root>-export`. */
export function TableActionsMenuExportItem(props: ShortcutItemProps): null {
  void props;
  return null;
}
TableActionsMenuExportItem.displayName = "TableActionsMenu.ExportItem";
TableActionsMenuExportItem.toItem = (
  props: ShortcutItemProps,
  partTestId: (part: string) => string | undefined,
): ItemProps => ({
  ...props,
  label: TABLE_ACTIONS_EXPORT_LABEL,
  icon: "download",
  testId: partTestId("export"),
});
